// @generated by TypeGen from LogbookModel/Engine.swift - DO NOT EDIT

export interface IEngineCalculations {
  distance?: number;
  duration?: number;
  number?: number;
  state?: IEngineState;
}

export enum IEngineState {
  running = "running",
  started = "started",
  stopped = "stopped",
}
